import { render, staticRenderFns } from "./VoucherInfo.vue?vue&type=template&id=50c50eca&scoped=true"
import script from "./VoucherInfo.vue?vue&type=script&lang=js"
export * from "./VoucherInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50c50eca",
  null
  
)

export default component.exports